/**
 *    __________ ______ Copyright (C) Smart Software Factory SA de CV
 *   / ___/ ___// ____/ All Rights Reserved
 *   \__ \__ \ / /_     Unauthorized copying of this file,
 *  ___/ /__/ / __/     via any medium is strictly prohibited
 * /____/____/_/        Proprietary and confidential
 *
 * Written by Ricardo Sansores <ricardo@ssf.mx>, May 2019
 *
 * Define the popups that can be launched from anyware in the app
 * and the messages are stadarized thru this class.
 */

import { message as Message } from 'antd';
import { parseApiError } from 'commons/error';
import { ExceptionMessage } from 'types/type';

const MESSAGE_DURATION = 5;

export class Popups {
  /**
   * Creates a Success Popopup in the application with
   * a given Message.
   */
  public static notifySuccess = (message: string): void => {
    Message.success(message, MESSAGE_DURATION);
  };

  public static notifyWarning = (message: string): void => {
    Message.warning(message, MESSAGE_DURATION);
  };

  /**
   * Creates an error popup in the application with a given
   * exception.
   */
  public static notifyException = (message: ExceptionMessage): void => {
    Message.error(parseApiError(message).description);
  };

  /**
   * Just like notify Exception, this creates an error message
   * in a popup
   */
  public static notifyError = (message: string): void => {
    Message.error(message, MESSAGE_DURATION);
  };

  /**
   * Is a common patter to try something and if success send a message if fail
   * throw a message with the error in a popup. This funcion abstracs this pattern
   * avoiding try catch.
   */

  public static executeOrNotifyError = (
    f: () => Promise<void>,
    message?: string,
  ): void => {
    try {
      f();
      if (message !== undefined) {
        Popups.notifySuccess(message);
      }
    } catch (err) {
      Popups.notifyException(err);
    }
  };
}
